import api from './client';

export interface InvitationActionResponse {
  message?: string;
}

export async function acceptInvite(inviteCode: string) {
  return api.post(`/notifications/invitations/${inviteCode}/accept`);
}

export async function rejectInvite(inviteCode: string) {
  return api.post(`/notifications/invitations/${inviteCode}/reject`);
}

export async function withdrawInvite(familyId: string, inviteCode: string) {
  return api.delete(`/families/${familyId}/invitations/${inviteCode}`);
}

